import { Controller } from '@hotwired/stimulus'
import consumer from '../channels/consumer'

export default class extends Controller {
  static targets = ['badge']

  static values = {
    orderId: Number,
    assignmentId: Number,
    userId: Number,
    unreadCount: { type: Number, default: 0 }
  }

  connect () {
    this.seenMessageIds = new Set()
    this.renderBadge(this.unreadCountValue)

    this.subscription = consumer.subscriptions.create(
      { channel: 'UserChatNotificationsChannel' },
      { received: (data) => this.receive(data) }
    )
  }

  disconnect () {
    if (this.subscription) this.subscription.unsubscribe()
  }

  receive (data) {
    if (data?.type !== 'chat_message') return
    if (Number(data.delivery_assignment_id) !== this.assignmentIdValue) return
    if (Number(data.recipient_id) !== this.userIdValue) return

    const messageId = String(data.message_id || '')
    if (!messageId || this.seenMessageIds.has(messageId)) return
    this.seenMessageIds.add(messageId)

    this.renderBadge(Number(data.unread_count) || this.unreadCountValue + 1)
  }

  renderBadge (count) {
    this.unreadCountValue = Math.max(0, Number(count) || 0)
    if (!this.hasBadgeTarget) return

    this.badgeTarget.textContent = this.unreadCountValue > 99 ? '99+' : String(this.unreadCountValue)
    this.badgeTarget.classList.toggle('hidden', this.unreadCountValue === 0)
  }

}
